import React from "react";
import { motion } from "framer-motion";
import { RevealHeading } from "../RevealHeading";
import { media } from "../../data/media";
import { sectionHeading } from "../../utils/typography";
const metrics = [{
  value: "10+",
  label: "Years experience"
}, {
  value: "50+",
  label: "Companies"
}, {
  value: "Worldwide",
  label: "Global collaboration"
}];
export function AboutSection() {
  return <section id="about" aria-labelledby="about-heading" className="border-y border-white/10 bg-[#070b0b] px-5 py-24 md:px-8 md:py-32" data-id="element-39" data-mp="3m159geopt8bk">
      <div className="mx-auto grid max-w-[1480px] gap-12 lg:grid-cols-12 lg:gap-20" data-id="element-40" data-mp="3h2ar1duntlrz">
        <div className="lg:col-span-5" data-id="element-41" data-mp="3c9re8j3squo8">
          <motion.figure className="relative overflow-hidden rounded-[20px] border border-white/10" initial={{
          opacity: 0,
          y: 26
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: "-12%"
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-42" data-mp="3c8pvdsgjh3vy">
            <img src={media.portrait} alt="Portrait of Syed Muhammad Zeeshan" className="aspect-[4/5] w-full object-cover" loading="lazy" data-id="element-43" data-mp="1ld8evujcoiwc" />
            <div className="absolute inset-0 bg-[linear-gradient(to_top,rgba(5,8,8,0.92),transparent_55%)]" data-id="element-44" data-mp="1qbs5474z8gui" />
            <figcaption className="absolute inset-x-6 bottom-6" data-id="element-45" data-mp="1blkqk2i3bhz3">
              <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#54f6c6]" data-id="element-46" data-mp="1glgvq52ixfg8">Profile / Worldwide</p>
              <p className="mt-3 font-heading text-3xl font-semibold tracking-[-0.045em] text-white" data-id="element-47" data-mp="12lpbhmlez2ts">SM Zeeshan</p>
              <p className="mt-3 flex flex-wrap items-center gap-x-2 gap-y-1 font-mono text-[11px] uppercase tracking-[0.14em] text-white/60" data-id="element-48" data-mp="16mhpet58dvwe">
                <span data-id="element-49" data-mp="xn4ctrlt8r7g">Senior 2D &amp; 3D Motion Designer</span>
                <span aria-hidden="true" className="text-white/30" data-id="element-50" data-mp="xpqreb74c6z6">|</span>
                <span data-id="element-51" data-mp="2n3n871m43r6x">VFX Artist</span>
                <span aria-hidden="true" className="text-white/30" data-id="element-52" data-mp="2s1oqhkbprmhc">|</span>
                <span data-id="element-53" data-mp="2rzkqhdgxr7mc">CGI Generalist</span>
              </p>
            </figcaption>
            <span className="absolute right-5 top-5 font-mono text-[11px] tracking-[0.18em] text-white/45" data-id="element-54" data-mp="2qm2xkckaqv8d">A/01</span>
          </motion.figure>
        </div>
        <div className="lg:col-span-7" data-id="element-55" data-mp="2glshmk6vn9pi">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#54f6c6]" data-id="element-56" data-mp="2gmu3ljpflgm0">005 / About</p>
          <RevealHeading as="h2" id="about-heading" lines={["Bridging traditional CGI", "with modern AI production"]} accent="CGI" className={`mt-8 ${sectionHeading}`} data-id="element-57" data-mp="2bpbw7xr2b9g4" />
          <p className="mt-8 max-w-2xl text-sm leading-7 text-white/60 md:mt-10 md:text-base md:leading-8" data-id="element-58" data-mp="2zky1tj3s5v91">
            I am a pipeline-focused Senior Motion Graphic Designer & VFX Artist working worldwide. Over the past decade, I have spearheaded end-to-end animation and post-production workflows across leading tech-IT, digital agencies, production and animation houses.
          </p>
          <p className="mt-6 max-w-2xl text-sm leading-7 text-white/60 md:text-base md:leading-8" data-id="element-59" data-mp="3vjofwragi1ez">
            By combining traditional CGI ecosystems, Cinema 4D with Octane Render, and generative AI tools, I build ultra-efficient, scalable animation pipelines without compromising visual fidelity. From complex rotoscoping and cleanplating in After Effects to seamless compositing, I deliver polished, cinema-grade assets built to scale.
          </p>
          <div className="mt-12 grid grid-cols-3 gap-x-4 gap-y-6 border-t border-white/10 pt-8 sm:gap-6 md:mt-16" data-id="element-60" data-mp="icmxs2l1e8vb">
            {metrics.map(metric => <div key={metric.label} data-id="element-61" data-mp="r4ybcnv1y1tv">
                <p className="break-words text-[clamp(1.15rem,4vw,3rem)] font-medium leading-none tracking-[-0.055em] text-white" data-id="element-62" data-mp="r6001v4zqmu2">{metric.value}</p>
                <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.16em] text-white/45" data-id="element-63" data-mp="113w82e2mt1ny">{metric.label}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}